export const ERROR_CODE = {
  AUTHENTICATION_ERROR: 'AuthenticationError',
  AUTHENTICATION_REQUIRED: 'AuthenticationRequired',
  PERMISSION_DENIED: 'PermissionDenied',
}
